import DATEPICKER_OR from "../../../../common/custom-form/custom-date-picker.component";

const Polkomtel = (props) => {
  return (
    <DATEPICKER_OR
      dateOnly={true}
      label={props.Datelabel}
      startDate={props.startDate || null}
      selectedDate={props.selectedDate}
      placeholder={props.placeholder}
      requiredField={true}
    />
  );
};

export default Polkomtel;
